<div fxLayout="row" fxLayoutAlign="center" >
  <mat-spinner color="primary" ></mat-spinner>
</div>

